import { CompetitionTeams } from '../../data/competition-teams';
import {
  Leaderboard,
  LeaderboardPlayer,
  GameroundPrize,
  Teams,
  TeamPlayers,
} from '../../data/competition-data';
import { ServerResult } from '../../data/server-result';
import { AuthenticationService } from '../../authentication-service';
import { DeviceService } from '../device-service/device-service';
import { Preference } from '../../storage/preference';
import { isPresent } from 'src/providers/common-service';
import { Custom_RequestMethod } from '../common-service';
import { throwError, Observable, BehaviorSubject } from 'rxjs';
import { RemoteHttpService } from '../../remote-http';
import {
  CompetitionList,
  PlainScoreCard,
  CompetitionPlayerInfo,
  CompetitionInfo,
  CompetitionDetails,
  FlightInfo,
  FlightMember,
  CompetitionSponsorInfo,
  CompetitionPrizeInfo,
  CompetitionData,
  FindTeeTimeCriteria,
} from '../../data/mygolf.data';
import { SearchCriteria } from '../../data/search-criteria';
import { Injectable } from '@angular/core';
// import { RemoteRequest } from 'src/remote-request';
import * as global from '../../globals';
import { ContentType, RemoteRequest } from '../../remote-request';
import { ScorecardService } from '../scorecard-service/scorecard-service';
import { JsonService } from '../../json-util';
import * as moment from 'moment';
import { catchError, map } from 'rxjs/operators';
// import { ClubFlightService } from '../club-flight-service/club-flight-service';

@Injectable()
export class BookingService {
  private searchCriteria: FindTeeTimeCriteria;
  private startDate: Date;
  private endDate: Date;
  private selectedRoundNo: number;
  private selectedCategoryId: string;
  private selectedOrderBy: number;
  private isPrivate: boolean = false;
  private isTeamEvent: boolean = false;

  private sortedPrizes: Array<string>;

  private clubId: number = null;
  constructor(
    private http: RemoteHttpService,
    public requestMethod: Custom_RequestMethod,
    private auth: AuthenticationService,
    private deviceService: DeviceService,
    private pref: Preference,
    // private flightService: ClubFlightService

  ) {

    this.pref.getPref("FindTeeTimesFilter")
      .subscribe((data: any) => {
        console.debug("booking service - get pref", data)
        if(data) {
          this.searchCriteria = data;
        } else {
          this.initSearch();
        }
      },(error)=>{
        this.initSearch();
      })
    // this.pref.getPref("FindTeeTimesFilter")
    //   .subscribe((data: any) => {
    //     if (data) {
    //       this.searchCriteria = data;
    //       if (this.searchCriteria != null && !this.searchCriteria.maxDistance)
    //         this.searchCriteria.maxDistance = 10;
    //       if (global.appType === 'club' && global.clubId) {
    //         this.searchCriteria.clubId = global.clubId;
    //         this.searchCriteria.searchWithinDistance = false;
    //         this.searchCriteria.onlyParticipating = false;
    //         this.searchCriteria.maxDistance = 10;
    //         this.searchCriteria.onlyFavorites = false;
    //       }
    //     }
    //   }, (error) => {

    //   });

    if (global.appType === 'club' && global.clubId) {
      this.clubId = global.clubId;
    }



    //    private static PreferenceTable: string = "preference";
    //    private static key: string = "FindTeeTimesFilter";
  }

  initSearch() {


    this.searchCriteria = {

      startDate: moment().add(1,'d').format("YYYY-MM-DD"),
      fromTime: '07:00',
      toTime: '19:00',
      filterCountry: null,
      selectClubType: 'allClubs',
      userType: '',
      countryList: '',
      filteredLocation: '',
      courseInfo: '',
      courseType: '',
      searchDistance: 50,
      clubInfo: '',
      appAttribute: '',
      geo: '',
      countryId: '',
      clubId: null,
      courseId: null

    };
    this.setSearch(this.searchCriteria);
    console.debug("booking service - init search", this.searchCriteria);
  }

  /**
    * Gets the preference stored
    * @returns {FindTeeTimeCriteria}
    */
  public getSearch(): FindTeeTimeCriteria {
    return this.searchCriteria;
  }

  // public search() {
  //   return 'hello';
  // }

  public setSearch(search: FindTeeTimeCriteria) {

    console.debug("set booking search", search, this.searchCriteria);
    this.searchCriteria = search;
    // if (this.searchCriteria != null && !this.searchCriteria.maxDistance)
    //   this.searchCriteria.maxDistance = 10;

    //Save it
    this.pref.setPref("FindTeeTimesFilter", search);
  }

  public setFilterStartDate(startDate: Date) {
    this.startDate = startDate;
  }

  public setFilterEndDate(endDate: Date) {
    this.endDate = endDate;
  }

  public setLeaderboardFilter(
    orderBy: number = 2,
    roundNo?: number,
    categoryId?: string,
    isTeamEvent?: boolean
  ) {
    // this.selectedRoundNo = roundNo;
    // if (categoryId == '0') {

    //   this.selectedCategoryId = null;
    //   this.searchCriteria.competitionLeaderboardGroupBy = '';
    // } else {

    //   this.selectedCategoryId = categoryId;
    //   this.searchCriteria.competitionLeaderboardGroupBy =
    //     this.selectedCategoryId;
    // }

    // this.selectedOrderBy = orderBy;
    // this.searchCriteria.competitionLeaderboardSortBy = this.selectedOrderBy;

    // this.isTeamEvent = isTeamEvent;
  }

  public setPrivate(isPrivate: boolean) {
    this.isPrivate = isPrivate;
  }

  public getCompetitionsInProgress(
    playerId: number
  ): Observable<Array<CompetitionInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.activeCompetitions,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        playerId: playerId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let comps: any = resp;
          comps.forEach((c) => {
            JsonService.deriveFullUrl(c, 'imageUrl');
            JsonService.deriveFullUrl(c, 'thumbnail');
            JsonService.deriveDates(c, [
              'startDate',
              'endDate',
              'publishDate',
              'openDate',
              'closeDate',
            ]);
          });
          return comps;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Load the next page of competitions based on your search criteria
   * @param pageNo The
   * @returns {Observable<CompetitionList>} The competitions are already adjusted with absolute URLs
   * for images and the dates are converted from string
   */
  public search(pageNo: number = 1, searchText: string): Observable<CompetitionList> {
    let request = this.createSearchRequest(pageNo, searchText);
    return this.searchCompetitions(request);
  }

  /**
   * Gets the information of a component
   * @param competitionId
   */
  public getCompetitionInfo(
    competitionId: number
  ): Observable<CompetitionInfo> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionInfo,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compInfo: any = resp;

          JsonService.deriveFullUrl(compInfo, 'imageUrl');
          JsonService.deriveFullUrl(compInfo, 'thumbnail');
          JsonService.deriveDates(compInfo, [
            'startDate',
            'endDate',
            'publishDate',
            'openDate',
            'closeDate',
          ]);
          return compInfo;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Gets the competition details for a given competition
   * @param competitionId The ID of the competition for which details are required
   * @returns {Observable<R>} The URLs are already sanitized and absolute
   */
  public getDetails(competitionId: number): Observable<CompetitionDetails> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionDetails,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let details: any = resp;
          if (details.gameRounds)
            details.gameRounds.forEach((gr) =>
              JsonService.deriveDates(gr, ['roundDate'])
            );

          if (details.sponsors)
            details.sponsors.forEach((s) =>
              JsonService.deriveFullUrl(s, 'imageUrl')
            );

          if (details.players)
            details.players.forEach((p) => {
              JsonService.deriveDates(p, ['registeredOn']);
              JsonService.deriveFullUrl(p, 'photoUrl');
            });
          return details;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Get active list of competitions for a given club
   * @param clubId
   * @returns {Observable<R>}
   */
  public getActiveCompetitionsForClub(
    clubId: number
  ): Observable<Array<CompetitionInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.activeCompetitionsForClub,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
      }
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let comps: any = resp;
        comps.forEach((comp) => {
          JsonService.deriveFullUrl(comp, 'imageUrl');
        });
        return comps;
      })
    ).pipe(catchError(this.http.handleError))
  }
  /**
   * Get active list of competitions for a given organizer
   * @param organizerId The ID of the organizer
   * @returns {Observable<R>}
   */
  public getActiveCompetitionsForOrganizer(
    organizerId: number
  ): Observable<Array<CompetitionInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.activeCompetitionsForOrganizer,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        organizerId: organizerId,
      }
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let comps: any = resp;
        comps.forEach((comp) => {
          JsonService.deriveFullUrl(comp, 'imageUrl');
        });
        return comps;
      })
    ).pipe(catchError(this.http.handleError))
  }
  /**
   * Gets the flights for a given competition and round number
   * @param competitionId The ID of the competition.
   * @param roundNo The round number
   * @returns {Observable<R>} Returns an Observable of array of flight info
   */
  public getFlights(
    competitionId: number,
    roundNo: number
  ): Observable<Array<FlightInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionFlights,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        roundNo: roundNo,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {

          let flights = resp;
          flights.forEach((flight: FlightInfo) => {
            //    JsonService.deriveTime(flight, ["startTime"]);
            // flight.startTime = moment(flight.startTime).format("HH:mm")
            flight.flightMembers.forEach((m: FlightMember) => {
              JsonService.deriveFullUrl(m, 'photoUrl');
            });
          });
          return flights;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Gets all the sponsors for a given competition from the server
   * @param competitionId The ID of the competition
   * @returns {Observable<R>} Returns an Observable which you can subscribe for result.
   */
  public getSponsors(
    competitionId: number
  ): Observable<Array<CompetitionSponsorInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionSponsors,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let sponsors: any = resp;
          if (sponsors) {
            sponsors.forEach((s: CompetitionSponsorInfo) => {
              JsonService.deriveFullUrl(s, 'imageUrl');
            });
          }
          return sponsors;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Gets the list of competition prizes.
   * @param competitionId The ID of the competition
   * @returns {Observable<R>} Returns the Obersvable which you can subscribe for extracting result.
   */
  public getPrizes(
    competitionId: number
  ): Observable<Array<CompetitionPrizeInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionPrizes,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let prizes: any = resp;
          return prizes;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Get the list of players registered for the given competition.
   * @param competitionId The ID of the competition
   * @param sortBy Sort option. default value is "name". Another options is "handicap"
   * @returns {Observable<R>}
   */
  public getPlayersRegistered(
    competitionId: number,
    sortBy: string = 'name'
  ): Observable<Array<CompetitionPlayerInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionPlayers,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        sortBy: sortBy,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let players: Array<CompetitionPlayerInfo> = resp;
          if (players)
            players.forEach((p: CompetitionPlayerInfo) => {
              JsonService.deriveDates(p, ['registeredOn']);
              JsonService.deriveFullUrl(p, 'photoUrl');
            });
          return players;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Get the scorers in the given competition round
   * @param competitionId The ID of the competition
   * @param roundNo The round number
   * @returns {Observable<R>}
   */
  public getScorers(
    competitionId: number,
    roundNo: number
  ): Observable<Array<CompetitionPlayerInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionScorers,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        roundNo: roundNo,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let players: any = resp;
          if (players)
            players.forEach((p: CompetitionPlayerInfo) => {
              JsonService.deriveDates(p, ['registeredOn']);
              JsonService.deriveFullUrl(p, 'photoUrl');
            });
          return players;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Registers a palyer for the competition.
   * @param competitionId The ID of the competition
   * @param playerId The player id
   * @returns {Observable<R>} returns the
   */
  public register(
    competitionId: number,
    playerId: number,
    ignoreOverlap: boolean
  ): Observable<ServerResult> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionRegister,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        playerId: playerId,
        ignoreOverlap: ignoreOverlap,
      }
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError))
  }

  /**
   * De-Registers a player from the competition
   * @param competitionId The ID of the competition
   * @param playerId The ID of the player to de-register
   * @returns {Observable<R>}
   */
  public deregister(
    competitionId: number,
    playerId: number
  ): Observable<ServerResult> {
    let _compId = competitionId;
    let _url;
    // _url = global.ServerUrls.competitionDeregister+"/"+_compId;
    _url = global.ServerUrls.competitionDeregister;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        playerId: playerId,
      }
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError))
  }

  /**
   * For a given competition, creates or gets the created scorecard
   * @param competitionId
   * @returns {Observable<R>}
   */
  public getOrCreateScorecard(
    competitionId: number,
    breakLock?: boolean,
    playerId?: number
  ) {
    let hdrs = {};
    console.debug("[Player-Id] [0]", playerId);
    if (isPresent(playerId)) hdrs['Player-Id'] = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.competitionScorecardGetOrCreate,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        breakLock: breakLock,
      },
      hdrs
    );

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let scorecard: any = resp;
          console.debug("get or create ", scorecard, resp)
          ScorecardService.transform(scorecard);
          return scorecard;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  public notifyFlightInfoChange(
    competitionId: number,
    roundNo: number,
    flightNo: string,
    changedBy: number
  ): Observable<boolean> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionFlightChanged,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        roundNo: roundNo,
        flightNo: flightNo,
        playerId: changedBy,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result.success;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Withdraw a player from the competition
   * @param competitionId The ID of the competition
   * @param roundNo The round no
   * @param playerId The ID of the player to withdraw
   * @returns {Observable<R>}
   */
  public withdraw(
    competitionId: number,
    roundNo: number,
    playerId: number
  ): Observable<boolean> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionWithdraw,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        roundNo: roundNo,
        playerId: playerId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result.success;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   * Change the scorer for a given player
   * @param competitionId The ID of the competition
   * @param roundNo The round number
   * @param playerId The ID of the player for whom the scorer needs to be changed
   * @param scorerId The ID of the scorer
   * @returns {Observable<R>}
   */
  public changeScorer(
    competitionId: number,
    roundNo: number,
    playerId: number,
    scorerId: number
  ): Observable<boolean> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionChangeScorer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        roundNo: roundNo,
        playerId: playerId,
        scoringPlayerId: scorerId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result.success;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  /**
   *
   * For a given competition, get the scoring round number for the player
   * @param competitionId The ID of the competition
   * @returns {Observable<R>}
   */
  public getScoringRoundNumber(competitionId: number): Observable<number> {
    let request = new RemoteRequest(
      global.ServerUrls.competitionRoundForScoring,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
      }
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {

        // let round: number = parseInt(resp.text());
        let round: number = resp;
        return round;
      })
    ).pipe(catchError(this.http.handleError))
  }

  /**
   * Gets the leaderboard for a given competition & round number
   * @param competitionId
   * @param orderBy
   * @param roundNo
   * @param categoryId
   * @returns {Observable<R>} Returns the Observable which you can subscribe
   * with next method receiving Leaderboard object and all player image URLs processed.
   */
  // public getLeaderboard(
  //   competitionId: number,
  //   orderBy?: number,
  //   roundNo?: number,
  //   categoryId?: string,
  //   isTeamEvent?: boolean
  // ): Observable<Leaderboard> {
  //   if (!orderBy) orderBy = this.searchCriteria.competitionLeaderboardSortBy; //this.selectedOrderBy;

  //   if (!roundNo) roundNo = this.selectedRoundNo;

  //   if (!categoryId)
  //     categoryId = this.searchCriteria.competitionLeaderboardGroupBy; //this.selectedCategoryId;

  //   if (!isTeamEvent) isTeamEvent = this.isTeamEvent;

  //   let request = new RemoteRequest(
  //     global.ServerUrls.competitionLeaderboard,
  //     this.requestMethod.get,
  //     ContentType.URL_ENCODED_FORM_DATA,
  //     {
  //       competitionId: competitionId,
  //       roundNo: roundNo,
  //       categoryId: categoryId,
  //       orderBy: orderBy,
  //       isTeamEvent: isTeamEvent ? 'true' : 'false',
  //     }
  //   );

  //   return this.http
  //     .execute(request)
  //     .pipe(
  //       map((resp: any) => {
  //         let leaderBoard: any = resp;
  //         if (leaderBoard && leaderBoard.players)
  //           leaderBoard.players.forEach((p: LeaderboardPlayer) => {
  //             JsonService.deriveFullUrl(p, 'imageURL');
  //           });
  //         return leaderBoard;
  //       })
  //     )
  //     .pipe(catchError(this.http.handleError))
  // }

  /**
   * Returns the competition prizes grouped by round number and category name
   * @param compPrizes The competition prizes to group
   */
  public groupedPrizes(
    compPrizes: Array<CompetitionPrizeInfo>
  ): Array<GameroundPrize> {


    let result = new Array<GameroundPrize>();

    compPrizes.forEach((cp) => {
      let roundName =
        cp.roundNumber && cp.roundNumber !== 999
          ? 'Round ' + cp.roundNumber
          : 'Overall';
      let categoryName = cp.categoryName ? cp.categoryName : 'Overall';
      let categoryDisplaySequence = cp?.categoryDisplaySequence;
      let scoreType = cp.scoreType;
      let gameRoundPrize = result
        .filter((gp) => {
          return gp.roundName === roundName;
        })
        .pop();

      if (!gameRoundPrize) {
        gameRoundPrize = {
          roundName: roundName,
          categoryPrizes: [],
        };
        result.push(gameRoundPrize);
      }

      gameRoundPrize.categoryPrizes?.sort((a,b)=>{
        if(a?.scoreGroups?.some(asg => asg?.scoreType !== 'X') && b?.scoreGroups?.some(asg => asg?.scoreType === 'X')) return -1;
        else if(a?.scoreGroups?.some(asg => asg?.scoreType === 'X') && b?.scoreGroups?.some(asg => asg?.scoreType !== 'X')) return 1;
        else return 0;
      })

      let categoryPrize = gameRoundPrize.categoryPrizes
        .filter((categoryPrize) => {
          return categoryPrize.categoryName == categoryName;
        })
        .pop();
      if (!categoryPrize) {
        categoryPrize = {
          categoryName: categoryName,
          scoreGroups: [],
          categoryDisplaySequence: categoryDisplaySequence,
          // prizes: []
        };
        gameRoundPrize.categoryPrizes.push(categoryPrize);
      }

      let scoreGroup = categoryPrize.scoreGroups
        .filter((scoreGroup) => {
          return scoreGroup.scoreType == scoreType;
        })
        .pop();
      if (!scoreGroup) {
        scoreGroup = {
          scoreType: scoreType,
          prizes: [],
          // prizes: []
        };
        categoryPrize.scoreGroups.push(scoreGroup);
      }

      // let sortedPrizes = scoreGroup.prizes.sort((a,b)=>a.prizePosition.localeCompare(b.SupplierName));

      scoreGroup.prizes.push({
        title: cp.title,
        prizeName: cp.prizeName,
        order: cp.order,
        prizeMoney: cp.prizeMoney,
        playerPos: cp.playerPos,
        playerMon: cp.playerMon,
        teamPos: cp.teamPos,
        teamMon: cp.teamMon,
        prizePosition: cp.prizePosition,
      });
      scoreGroup.prizes.sort((a, b) => {
        if (a.prizePosition < b.prizePosition) return -1;
        else if (a.prizePosition > b.prizePosition) return 1;
        else return 0;
      });

    });

    result?.forEach((grp)=>{
      grp.categoryPrizes?.sort((a,b)=>{
        if(a?.scoreGroups?.some(sg => sg?.scoreType === 'X') && b?.scoreGroups?.some(sg => sg?.scoreType === 'X')) {
          if(a?.categoryDisplaySequence < b?.categoryDisplaySequence) return -1;
          else if(a?.categoryDisplaySequence > b?.categoryDisplaySequence) return 1;
          else return 0;
        } else return 0;
      })
    })

    console.debug("grouped prizes ", result)


    return result;
  }

  private searchCompetitions(
    request: RemoteRequest
  ): Observable<CompetitionList> {

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compList: any = resp;

          compList.competitions.forEach((comp: any, index: number) => {

            JsonService.deriveFullUrl(comp, 'imageUrl');
            JsonService.deriveFullUrl(comp, 'thumbnail');
            JsonService.deriveDates(comp, [
              'startDate',
              'endDate',
              'publishDate',
              'openDate',
              'closeDate',
            ]);
          });
          return compList;
        })
      )
      .pipe(catchError(this.http.handleError))



  }

  private createSearchRequest(pageNo: number = 1, searchText?: string): RemoteRequest {
    // return this._buildSearchRequest(
    //   pageNo,
    //   searchText,
    //   this.searchCriteria,
    //   this.startDate,
    //   this.endDate
    // );
    if (global.appType === 'club' && global.clubId) this.clubId = global.clubId;
    return this._buildSearchRequest(pageNo, searchText, this.searchCriteria, this.startDate, this.endDate, this.clubId);
  }

  private _buildSearchRequest(
    pageNo: number,
    searchText: string,
    searchCriteria: FindTeeTimeCriteria,
    startDate: Date,
    endDate: Date,
    clubId?: number
  ): RemoteRequest {
    let params = {
      pageNumber: pageNo,
      country: this.searchCriteria.countryId,
    };
    if (isPresent(searchText)) params['searchText'] = searchText;
    if (isPresent(startDate)) {
      let str = moment(startDate).format('YYYY-MM-DD');
      params['startDate'] = str;
    }
    if (isPresent(endDate))
      params['endDate'] = moment(endDate).format('YYYY-MM-DD');
    if (isPresent(clubId))
      params["clubId"] = clubId;
    params = JsonService.mergeObjects([params, searchCriteria]);
    if (0) {
      // && this.searchCriteria.searchType == 'private'
      return new RemoteRequest(
        global.ServerUrls.getPrivateCompetitionList,
        this.requestMethod.get,
        ContentType.URL_ENCODED_FORM_DATA,
        params
      );
    } else {
      return new RemoteRequest(
        global.ServerUrls.searchCompetitions,
        this.requestMethod.get,
        ContentType.URL_ENCODED_FORM_DATA,
        params
      );
    }
  }

  // private handleError(error) {
  //   let result: any;
  //   if (error && error.json) result = error.json();
  //   else if (error) result = error;
  //   else result = 'Server error occured';

  //   return throwError(result);
  // }

  public getCompetitionTeams(
    competitionId: number
  ): Observable<CompetitionTeams> {
    let request = new RemoteRequest(
      global.ServerUrls.getCompetitionTeamList,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compTeams: any = resp;
          compTeams.competitionTeams.forEach((team: Teams) => {
            JsonService.deriveTime(team, ['teamSessionTime']);
            if (team.teamLogo) JsonService.deriveFullUrl(team, 'teamLogo');

            team.teamPlayers.forEach((tp: TeamPlayers) => {
              if (tp.imageURL) JsonService.deriveFullUrl(tp, 'imageURL');
              if (tp.thumbnailURL)
                JsonService.deriveFullUrl(tp, 'thumbnailURL');
            });
          });

          return compTeams;
        })
      )
      .pipe(catchError(this.http.handleError))
  }

  public autoScoreCompetition(
    competitionId: number,
    roundNo: number,
    scorersToExclude: Array<number>,
    delayInSeconds: number
  ): Observable<boolean> {
    let req = new RemoteRequest(
      global.MygolfServer + '/rest/competition/autoscore',
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        roundNo: roundNo,
        excludedScorers: scorersToExclude,
        delayInSeconds: delayInSeconds,
      }
    );
    return this.http.execute(req).pipe(
      map((resp: any) => {
        let result: any = resp;
        return result.success;
      })
    ).pipe(catchError(this.http.handleError))
  }
  public releaseDeviceLock(
    competitionId: number,
    roundNo: number,
    scorerId: number
  ): Observable<boolean> {
    let deviceId = this.deviceService.getCachedDeviceInfo().deviceId;
    let req = new RemoteRequest(
      global.MygolfServer + '/rest/device/unlockcompetition',
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        roundNo: roundNo,
        scorerId: scorerId,
        deviceId: deviceId,
      }
    );
    return this.http
      .execute(req)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(map((result) => result.success))
      .pipe(catchError(this.http.handleError));
  }
  public breakAndAcquireDeviceLock(
    competitionId: number,
    roundNo: number,
    scorerId: number,
    flightNumber?: string
  ): Observable<ServerResult> {
    let req = new RemoteRequest(
      global.MygolfServer + '/rest/device/breaklock',
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: competitionId,
        roundNo: roundNo,
        scorerId: scorerId,
        flightNumber: flightNumber,
        deviceId: this.deviceService.getCachedDeviceInfo().deviceId,
      }
    );
    return this.http.execute(req).pipe(
      map((resp: any) => {
        let result: any = resp;
        return result;
      })
    ).pipe(catchError(this.http.handleError))
  }

  public isPlayerWithdrawn(
    compId: number,
    playerId: number
  ): Observable<boolean> {
    let req = new RemoteRequest(
      global.MygolfServer + '/rest/competition/isplayerwithdrawn',
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        competitionId: compId,
        playerId: playerId,
      }
    );
    return this.http.execute(req).pipe(
      map((resp: any) => {
        let result = resp;
        return result;
      })
    )
      .pipe(catchError(this.http.handleError))
  }

  public testAPIcall(): Observable<any> {




    let param_ = {
      my_message: 'Test message here',
      amount: '123',
      paid_date: '2019-03-03',
      paid_days: '3',
    };
    let request = new RemoteRequest(
      'http://v23.mygolf2u.com/payment/test-call?my_message=' +
      param_.my_message +
      '&amount=' +
      param_.amount +
      '&paid_date=' +
      param_.paid_date +
      '&paid_days=' +
      param_.paid_days,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
      // {
      //     my_message: 'Test message here',
      //     amount: '123',
      //     paid_date: '2019-03-03',
      //     paid_days: '3'
      // }
    );

    return this.http
      .execute(request)
      .pipe(map((resp: any) => { }))
      .pipe(catchError(this.http.handleError))

    // let request = new RemoteRequest(global.ServerUrls.competitionPlayers,
    //     this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
    //         competitionId: competitionId,
    //         sortBy       : sortBy
    //     });
    // return this.http.execute(request)
    //            .map((resp: any) => {
    //                let players: Array<CompetitionPlayerInfo> = resp;
    //                if (players)
    //                    players.forEach((p: CompetitionPlayerInfo) => {
    //                        JsonService.deriveDates(p, ["registeredOn"]);
    //                        JsonService.deriveFullUrl(p, "photoUrl");
    //                    });
    //                return players;
    //            }).catch(this.handleError);
  }

  public setClubId(clubId: number) {
    this.clubId = clubId;
  }

  compData: CompetitionData;
  public setCompData(compData: CompetitionData) {
    console.debug("set comp data [nines]", compData)
    if(!compData) return;
    this.compData = compData;
  }

  public getCompData() {
    console.debug("get comp data [nines]", this.compData)
    return this.compData;
  }

  public clearCompData() {
    this.compData = null;
  }

  public async refreshCompData() {
    // await this.flightService.getCompetitionDetails(this.compData.id)
    // .subscribe((compData)=>{
    //   if(compData) {
    //     this.compData = compData;
    //     this.setCompData(compData);
    //     return compData;
    //   }
    // },(error)=>{

    // },()=>{
    // })
    // return this.compData;
  }



  bookingDoneClicked = new BehaviorSubject<boolean>(false);

  setBookingDoneClicked(newValue: boolean) {
    this.bookingDoneClicked.next(newValue);
  }
  getBookingDoneClicked() {
    return this.bookingDoneClicked.asObservable();
  }
}
